export default function ListSkeleton({ rows = 4 }) {
  return (
    <div className="space-y-3">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="rounded-xl border border-neutral-200 bg-white p-4 animate-pulse">
          <div className="h-3 w-1/4 bg-neutral-100 rounded mb-2" />
          <div className="h-4 w-2/3 bg-neutral-100 rounded" />
        </div>
      ))}
    </div>
  );
}
